const MODULE = document.querySelectorAll('[data-module="header"]');
const SCROLL_THRESHOLD = 100;

class SiteHeader {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const menuBtn = component.querySelector('.btn-menu-mobile');

            if (menuBtn) {
                menuBtn.addEventListener('click', () => this.toggleMenu(component, menuBtn));
            }

            this.bindScroll(component);
        });
    }

    bindScroll(component) {
        const onScroll = () => {
            component.classList.toggle('is-scrolled', window.scrollY >= SCROLL_THRESHOLD);
        };

        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
    }

    toggleMenu(component, menuBtn) {
        const isOpen = component.classList.toggle('is-menu-open');
        menuBtn.setAttribute('aria-expanded', isOpen);
        document.body.classList.toggle('block-scroll', isOpen);
    }
}

(() => {
    if (MODULE.length) {
        new SiteHeader();
    }
})();

export default SiteHeader;
